module.exports = __webpack_public_path__ + "img/1.11bdcd7b.jpg";